import React from 'react';
import './loader.css';  // Import the CSS file

const EJILAnimatedLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader-content">
        <div className="loader-pings">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="ping-circle"
              style={{
                animationDelay: `${index * 0.3}s`,
                animationDuration: '1.5s',
                opacity: 0.7 - index * 0.2
              }}
            ></div>
          ))}
          <div className="loader-icon">
            <svg
              className="icon-bounce"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M2 17L12 22L22 17" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M2 12L12 17L22 12" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>
        <h2 className="loader-title">EJIL Enterprise</h2>
        <p className="loader-subtitle">Loading your digital experience...</p>
      </div>
    </div>
  );
};

export default EJILAnimatedLoader;
